"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "@/components/ui/Link";
import LiveBlink from "@/components/ui/LiveBlink";
import { isLiveBlogValue } from "@/lib/liveBlog";
import { useRouter } from "next/navigation";
import { MessageIcon } from "../ui/message-icon";
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getTimeAgo, getSectionUrl, getFocusPointStyle, toFieldString, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';
type FieldConfig = {
  hidden?: boolean;
  value?: string | boolean;
  customClass?: string;
};
type Props = {
  category?: FieldConfig;
  sectionUrl?: string;
  title?: FieldConfig;
  excerpt?: FieldConfig;
  timeAgo?: FieldConfig;
  imageSrc?: FieldConfig;
  slug?: string;
  priority?: boolean;
  imageMetadata?: ImageMetadata;
  templatetype?: FieldConfig;
  isliveblog?: FieldConfig;
};
export const VerticalMediamImageCategoryNews = t0 => {
  const $ = _c(70);
  const {
    category: t1,
    sectionUrl,
    title: t2,
    excerpt: t3,
    timeAgo: t4,
    imageSrc: t5,
    slug,
    priority: t6,
    imageMetadata,
    templatetype: t7,
    isliveblog: t8
  } = t0;
  let t9;
  if ($[0] !== t1) {
    t9 = t1 === undefined ? {
      hidden: false,
      value: "SPORT",
      customClass: ""
    } : t1;
    $[0] = t1;
    $[1] = t9;
  } else {
    t9 = $[1];
  }
  const category = t9;
  let t10;
  if ($[2] !== t2) {
    t10 = t2 === undefined ? {
      hidden: false,
      value: "\u0B9A\u0BA4\u0BAE\u0BCD \u0BB5\u0BBF\u0BB3\u0BBE\u0B9A\u0BBF\u0BAF \u0B95\u0BCD\u0BB3\u0BBE\u0B9A\u0BC6\u0BA9\u0BCD: \u0BAA\u0BC6\u0B99\u0BCD\u0B95\u0BB3\u0BC2\u0BB0\u0BC1\u0B95\u0BCD\u0B95\u0BC1 187 \u0BB0\u0BA9\u0BCD\u0B95\u0BB3\u0BCD \u0B87\u0BB2\u0B95\u0BCD\u0B95\u0BC1! \u0B95\u0BCD\u0BB3\u0BBE\u0B9A\u0BC6\u0BA9\u0BCD",
      customClass: ""
    } : t2;
    $[2] = t2;
    $[3] = t10;
  } else {
    t10 = $[3];
  }
  const title = t10;
  let t11;
  if ($[4] !== t3) {
    t11 = t3 === undefined ? {
      hidden: false,
      value: "\u0BB0\u0BBE\u0BAF\u0BB2\u0BCD \u0B9A\u0BC7\u0BB2\u0B9E\u0BCD\u0B9A\u0BB0\u0BCD\u0BB8\u0BCD \u0BAA\u0BC6\u0B99\u0BCD\u0B95\u0BB3\u0BC2\u0BB0\u0BC1\u0BB5\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0B8E\u0BA4\u0BBF\u0BB0\u0BBE\u0B95 \u0BAE\u0BC1\u0BA4\u0BB2\u0BBF\u0BB2\u0BCD \u0BAA\u0BC7\u0B9F\u0BCD \u0B9A\u0BC6\u0BAF\u0BCD\u0BA4 \u0B9A\u0BA9\u0BCD \u0BB0\u0BC8\u0B9A\u0BB0\u0BCD\u0BB8\u0BCD",
      customClass: ""
    } : t3;
    $[4] = t3;
    $[5] = t11;
  } else {
    t11 = $[5];
  }
  const excerpt = t11;
  const timeAgo = t4 === undefined ? {
    hidden: false,
    value: "May 17, 2023",
    customClass: ""
  } : t4;
  const imageSrc = t5 === undefined ? {
    hidden: false,
    value: FALLBACK_IMAGE,
    customClass: ""
  } : t5;
  const priority = t6 === undefined ? false : t6;
  let t12;
  if ($[6] !== t7) {
    t12 = t7 === undefined ? {
      hidden: false,
      value: "",
      customClass: ""
    } : t7;
    $[6] = t7;
    $[7] = t12;
  } else {
    t12 = $[7];
  }
  const templatetype = t12;
  let t13;
  if ($[8] !== t8) {
    t13 = t8 === undefined ? {
      hidden: false,
      value: "",
      customClass: ""
    } : t8;
    $[8] = t8;
    $[9] = t13;
  } else {
    t13 = $[9];
  }
  const isliveblog = t13;
  const router = useRouter();
  const t14 = category?.value;
  let t15;
  if ($[10] !== t14) {
    t15 = toFieldString(t14);
    $[10] = t14;
    $[11] = t15;
  } else {
    t15 = $[11];
  }
  const categoryValue = t15;
  const t16 = title?.value;
  let t17;
  if ($[12] !== t16) {
    t17 = toFieldString(t16);
    $[12] = t16;
    $[13] = t17;
  } else {
    t17 = $[13];
  }
  const titleValue = t17;
  const t18 = excerpt?.value;
  let t19;
  if ($[14] !== t18) {
    t19 = toFieldString(t18);
    $[14] = t18;
    $[15] = t19;
  } else {
    t19 = $[15];
  }
  const excerptValue = t19;
  const timeAgoValue = getTimeAgo(toFieldString(timeAgo?.value));
  const imageSrcValue = getImageUrl(toFieldString(imageSrc?.value)) || FALLBACK_IMAGE;
  let t20;
  if ($[16] !== isliveblog?.value || $[17] !== templatetype?.value) {
    t20 = isLiveBlogValue(templatetype?.value) || isLiveBlogValue(isliveblog?.value);
    $[16] = isliveblog?.value;
    $[17] = templatetype?.value;
    $[18] = t20;
  } else {
    t20 = $[18];
  }
  const isLiveBlog = t20;
  let t21;
  if ($[19] !== sectionUrl) {
    t21 = getSectionUrl(sectionUrl);
    $[19] = sectionUrl;
    $[20] = t21;
  } else {
    t21 = $[20];
  }
  const sectionUrlValue = t21;
  let t22;
  if ($[21] !== router || $[22] !== sectionUrlValue) {
    t22 = e => {
      if (sectionUrlValue) {
        e.preventDefault();
        e.stopPropagation();
        router.push(sectionUrlValue);
      }
    };
    $[21] = router;
    $[22] = sectionUrlValue;
    $[23] = t22;
  } else {
    t22 = $[23];
  }
  const handleCategoryClick = t22;
  let t23;
  if ($[24] !== imageMetadata || $[25] !== imageSrc?.customClass || $[26] !== imageSrc?.hidden || $[27] !== imageSrcValue || $[28] !== priority || $[29] !== titleValue) {
    t23 = !imageSrc?.hidden && <div><div className="relative w-full aspect-[16/9] overflow-hidden"><Image src={imageSrcValue} alt={titleValue} fill={true} sizes="(max-width: 768px) 100vw, (max-width: 1200px) 33vw, 300px" className={`object-cover w-full h-full ${imageSrc?.customClass || ""}`} style={getFocusPointStyle(imageMetadata)} loading={priority ? "eager" : "lazy"} fetchPriority={priority ? "high" : "auto"} priority={priority} placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} /></div></div>;
    $[24] = imageMetadata;
    $[25] = imageSrc?.customClass;
    $[26] = imageSrc?.hidden;
    $[27] = imageSrcValue;
    $[28] = priority;
    $[29] = titleValue;
    $[30] = t23;
  } else {
    t23 = $[30];
  }
  let t24;
  if ($[31] !== category?.customClass || $[32] !== category?.hidden || $[33] !== categoryValue || $[34] !== handleCategoryClick || $[35] !== sectionUrlValue) {
    t24 = !category?.hidden && (sectionUrlValue ? <span className={`text-11-tamil-600 text-012061 tracking-wide uppercase hover:underline cursor-pointer ${category?.customClass || ""}`} onClick={handleCategoryClick}>{categoryValue}</span> : <div className={`text-11-tamil-600 text-012061 tracking-wide uppercase ${category?.customClass || ""}`}>{categoryValue}</div>);
    $[31] = category?.customClass;
    $[32] = category?.hidden;
    $[33] = categoryValue;
    $[34] = handleCategoryClick;
    $[35] = sectionUrlValue;
    $[36] = t24;
  } else {
    t24 = $[36];
  }
  let t25;
  if ($[37] !== isLiveBlog || $[38] !== title?.customClass || $[39] !== title?.hidden || $[40] !== titleValue) {
    t25 = !title?.hidden && <h3 className={`text-14-tamil-700 leading-[1.4] text-1B1B1B ${title?.customClass || ""}`}>{isLiveBlog && <LiveBlink />}{titleValue}</h3>;
    $[37] = isLiveBlog;
    $[38] = title?.customClass;
    $[39] = title?.hidden;
    $[40] = titleValue;
    $[41] = t25;
  } else {
    t25 = $[41];
  }
  let t26;
  if ($[42] !== excerpt?.customClass || $[43] !== excerpt?.hidden || $[44] !== excerptValue) {
    t26 = !excerpt?.hidden && <p className={`text-12-tamil-500 text-4D4D4D leading-relaxed line-clamp-2 ${excerpt?.customClass || ""}`}>{excerptValue}</p>;
    $[42] = excerpt?.customClass;
    $[43] = excerpt?.hidden;
    $[44] = excerptValue;
    $[45] = t26;
  } else {
    t26 = $[45];
  }
  let t27;
  if ($[46] !== timeAgo?.customClass || $[47] !== timeAgo?.hidden || $[48] !== timeAgoValue) {
    t27 = !timeAgo?.hidden && <span className={`text-12-tamil-500 text-1B1B1B ${timeAgo?.customClass || ""}`}>{timeAgoValue}</span>;
    $[46] = timeAgo?.customClass;
    $[47] = timeAgo?.hidden;
    $[48] = timeAgoValue;
    $[49] = t27;
  } else {
    t27 = $[49];
  }
  const t28 = slug ? `/${slug}` : undefined;
  let t29;
  if ($[50] !== excerptValue || $[51] !== imageSrcValue || $[52] !== slug || $[53] !== t28 || $[54] !== titleValue) {
    t29 = <div className="flex gap-3"><MessageIcon id="message-icon-1" slug={slug} category={BOOKMARK_CATEGORIES.NEWS} title={titleValue} thumbnailUrl={imageSrcValue} description={excerptValue} articleUrl={t28} /></div>;
    $[50] = excerptValue;
    $[51] = imageSrcValue;
    $[52] = slug;
    $[53] = t28;
    $[54] = titleValue;
    $[55] = t29;
  } else {
    t29 = $[55];
  }
  let t30;
  if ($[56] !== t27 || $[57] !== t29) {
    t30 = <div className="flex justify-between items-center">{t27}{t29}</div>;
    $[56] = t27;
    $[57] = t29;
    $[58] = t30;
  } else {
    t30 = $[58];
  }
  let t31;
  if ($[59] !== t24 || $[60] !== t25 || $[61] !== t26 || $[62] !== t30) {
    t31 = <div className="flex flex-col gap-3">{t24}{t25}{t26}{t30}</div>;
    $[59] = t24;
    $[60] = t25;
    $[61] = t26;
    $[62] = t30;
    $[63] = t31;
  } else {
    t31 = $[63];
  }
  let t32;
  if ($[64] !== t23 || $[65] !== t31) {
    t32 = <div className="flex flex-col bg-F8F8F8 overflow-hidden p-4 gap-4">{t23}{t31}</div>;
    $[64] = t23;
    $[65] = t31;
    $[66] = t32;
  } else {
    t32 = $[66];
  }
  const content = t32;
  if (slug) {
    const t33 = `/${slug}`;
    let t34;
    if ($[67] !== content || $[68] !== t33) {
      t34 = <Link href={t33} className="block hover:bg-gray-100 transition-colors cursor-pointer">{content}</Link>;
      $[67] = content;
      $[68] = t33;
      $[69] = t34;
    } else {
      t34 = $[69];
    }
    return t34;
  }
  return content;
};